export default __webpack_public_path__ + "static/media/13.b092cfc4.png";